import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDisclosure, Drawer, DrawerOverlay, Mobile } from '@stockx/ui';
import { EllipsisIcon } from '@stockx/icons';
import { EditListModalContext } from '@account/pages/Favorites/context';
import { ListActionDrawer, ListEditDrawer } from '../ListDrawers';

type DrawerPage = 'Actions' | 'Edit' | 'Add';

const ListEditDropdownMobile = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [drawerPage, setDrawerPage] = useState<DrawerPage>('Actions'); // actions, edit, add item for now
  const [onUpdated, setOnUpdated] = useState(false);

  const handleActionClick = (page: DrawerPage) => {
    setDrawerPage(page);
  };

  useEffect(() => {
    if (onUpdated) {
      onClose();
      setOnUpdated(false);
    }
  }, [onClose, onUpdated]);

  const handleCloseDrawer = useCallback(() => {
    setDrawerPage('Actions');
  }, []);

  return (
    <EditListModalContext.Provider
      value={useMemo(
        () => ({
          isOpen,
          setOnUpdated,
          onToggle: handleCloseDrawer,
        }),
        [handleCloseDrawer, isOpen, setOnUpdated],
      )}
    >
      <Mobile>
        <button onClick={onOpen}>
          <EllipsisIcon boxSize="6" marginLeft="1" p="1" />
        </button>
        <Drawer placement="bottom" onClose={handleCloseDrawer} isOpen={isOpen}>
          <DrawerOverlay />
          {drawerPage === 'Actions' && (
            <ListActionDrawer handleActionClick={handleActionClick} />
          )}
          {drawerPage === 'Edit' && <ListEditDrawer />}
        </Drawer>
      </Mobile>
    </EditListModalContext.Provider>
  );
};

export default ListEditDropdownMobile;
